// import React, { useEffect, useState } from 'react';
// import axiosInstance from '../request';
// import { URL } from '../api';
// import getPrivilegeList from "./PrivilegeList";

// const EmployeeList = () => {
//   const [employees, setEmployees] = useState([]);
//   const [filterType, setFilterType] = useState('');
//   const [filterValue, setFilterValue] = useState('');
//   const [status, setStatus] = useState('');
//   const privilegeList = getPrivilegeList();

//   // Pagination states
//   const [currentPage, setCurrentPage] = useState(1);
//   const rowsPerPage = 10; // show 10 rows per page

//   const fetchEmployees = async () => {
//     try {
//       const params = new URLSearchParams();
//       if (filterType === 'userId') params.append('userId', filterValue);
//       if (filterType === 'userName') params.append('userName', filterValue);
//       if (status) params.append('is_active', status);

//       const res = await axiosInstance.get(`${URL.EMPLOYEE_LIST}?${params.toString()}`);
//       if (Array.isArray(res.data)) {
//         const uniqueMap = new Map();
//         res.data.forEach(emp => {
//           if (!uniqueMap.has(emp.user_id)) {
//             uniqueMap.set(emp.user_id, emp);
//           }
//         });
//         setEmployees(Array.from(uniqueMap.values()));
//         setCurrentPage(1); // reset to first page on search
//       } else {
//         setEmployees([]);
//       }
//     } catch (error) {
//       console.error('Error fetching employees:', error);
//       setEmployees([]);
//     }
//   };

//   useEffect(() => {
//     fetchEmployees();
//   }, []);

//   const handleKeyDown = (e) => {
//     if (e.key === 'Enter') {
//       e.preventDefault();
//       fetchEmployees();
//     }
//   };

//   // Pagination calculations
//   const totalPages = Math.ceil(employees.length / rowsPerPage);
//   const paginatedEmployees = employees.slice(
//     (currentPage - 1) * rowsPerPage,
//     currentPage * rowsPerPage
//   );

//   return (
//     <div className="container">
//       <h3 className="mb-4">Employee List</h3>

//       {/* Filter Section */}
//       <div className="card mb-4 p-3">
//         <div className="row gx-2 gy-2 align-items-end">
//           <div className="col-auto">
//             <label className="form-label">Filter Type</label>
//             <select
//               className="form-select form-select-sm"
//               value={filterType}
//               onChange={(e) => setFilterType(e.target.value)}
//               onKeyDown={(e) => e.preventDefault()}
//             >
//               <option value="">Select</option>
//               <option value="userId">User ID</option>
//               <option value="userName">Username</option>
//             </select>
//           </div>

//           {filterType && (
//             <div className="col-auto">
//               <label className="form-label">
//                 {filterType === 'userId' ? 'User ID' : 'Username'}
//               </label>
//               <input
//                 type={filterType === 'userId' ? 'number' : 'text'}
//                 className="form-control form-control-sm"
//                 value={filterValue}
//                 onChange={(e) => setFilterValue(e.target.value)}
//                 onKeyDown={handleKeyDown}
//               />
//             </div>
//           )}

//           <div className="col-auto">
//             <label className="form-label">Status</label>
//             <select
//               className="form-select form-select-sm"
//               value={status}
//               onChange={(e) => setStatus(e.target.value)}
//               onKeyDown={handleKeyDown}
//             >
//               <option value="">Select</option>
//               <option value="1">Active</option>
//               <option value="0">Inactive</option>
//             </select>
//           </div>

//           <div className="col-auto">
//             <button className="btn btn-sm btn-primary mt-1" onClick={fetchEmployees}>
//               Search
//             </button>
//           </div>
//         </div>
//       </div>

//       {/* Table Section */}
//       <div className="table-responsive">
//         <table className="table table-sm table-bordered table-hover align-middle">
//           <thead className="table-dark">
//             <tr>
//               <th>S.No.</th>
//               <th>User_ID</th>
//               <th>Username</th>
//               <th>Employee_Name</th>
//               <th>Department</th>
//               <th>Email</th>
//               <th>Phone</th>
//               <th>Status</th>
//               <th>Joining_Date</th>
//               {privilegeList.employeeEdit && <th>Action</th>}
//             </tr>
//           </thead>
//           <tbody>
//             {paginatedEmployees.length > 0 ? (
//               paginatedEmployees.map((emp, index) => (
//                 <tr key={emp.user_id}>
//                   <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>
//                   <td>{emp.user_id}</td>
//                   <td>{emp.user_name}</td>
//                   <td>{emp.name}</td>
//                   <td>{emp.dept}</td>
//                   <td>{emp.email}</td>
//                   <td>{emp.phone_number}</td>
//                   <td>
//                     <span
//                       className={`badge rounded-pill ${
//                         emp.is_active === 1 ? 'bg-success' : 'bg-secondary'
//                       }`}
//                     >
//                       {emp.is_active === 1 ? 'Active' : 'Inactive'}
//                     </span>
//                   </td>
//                   <td>{emp.create_date}</td>
//                   {privilegeList.employeeEdit && (
//                     <td>
//                       <button
//                         className="btn btn-sm btn-primary"
//                         onClick={() =>
//                           (window.location.href = `#/EmployeeView?UserId=${emp.user_id}`)
//                         }
//                       >
//                         Edit
//                       </button>
//                     </td>
//                   )}
//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan="10" className="text-center text-muted">
//                   No employee records found.
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>

//       {/* Pagination Controls */}
//       {employees.length > rowsPerPage && (
//         <div className="d-flex justify-content-center mt-3">
//           <div className="d-flex align-items-center overflow-auto" style={{ gap: '5px' }}>
//             {/* Prev */}
//             <button
//               className="btn btn-sm btn-outline-primary"
//               onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
//               disabled={currentPage === 1}
//             >
//               Prev
//             </button>

//             {/* Page numbers */}
//             {Array.from({ length: totalPages }, (_, i) => (
//               <button
//                 key={i + 1}
//                 className={`btn btn-sm ${
//                   currentPage === i + 1 ? 'btn-primary' : 'btn-outline-primary'
//                 }`}
//                 onClick={() => setCurrentPage(i + 1)}
//               >
//                 {i + 1}
//               </button>
//             ))}

//             {/* Next */}
//             <button
//               className="btn btn-sm btn-outline-primary"
//               onClick={() => setCurrentPage((p) => Math.min(p + 1, totalPages))}
//               disabled={currentPage === totalPages}
//             >
//               Next
//             </button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default EmployeeList;


import React, { useEffect, useState } from 'react';
import axiosInstance from '../request';
import { URL } from '../api';
import getPrivilegeList from "./PrivilegeList";

const EmployeeList = () => {
  const [employees, setEmployees] = useState([]);
  const [filterType, setFilterType] = useState('');
  const [filterValue, setFilterValue] = useState('');
  const [status, setStatus] = useState('');
  const privilegeList = getPrivilegeList();

  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;

  // ✅ GROUP FILTERS
  const employeeGroups = [250, 251, 400, 100, 1, 200];
  const dsaGroups = [1000, 1001];

  const fetchEmployees = async () => {
    try {
      const params = new URLSearchParams();

      if (filterType === 'userId') params.append('userId', filterValue);
      if (filterType === 'userName') params.append('userName', filterValue);
      if (status) params.append('is_active', status);

      const res = await axiosInstance.get(`${URL.EMPLOYEE_LIST}?${params.toString()}`);

      if (Array.isArray(res.data)) {
        const uniqueMap = new Map();

        res.data.forEach(emp => {
          if (!uniqueMap.has(emp.user_id)) {
            uniqueMap.set(emp.user_id, emp);
          }
        });

        setEmployees(Array.from(uniqueMap.values()));
        setCurrentPage(1);

      } else {
        setEmployees([]);
      }

    } catch (error) {
      console.error('Error fetching employees:', error);
      setEmployees([]);
    }
  };

  useEffect(() => {
    fetchEmployees();
  }, []);

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      fetchEmployees();
    }
  };

  // ✅ FILTER INTO SECTIONS
  const employeeSection = employees.filter(emp =>
    employeeGroups.includes(emp.group_id)
  );

  const dsaSection = employees.filter(emp =>
    dsaGroups.includes(emp.group_id)
  );

  // ✅ PAGINATION ONLY FOR EMPLOYEES
  const totalPages = Math.ceil(employeeSection.length / rowsPerPage);

  const paginatedEmployees = employeeSection.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  return (
    <div className="container">

      <h3 className="mb-4">Access Management List</h3>

      {/* Filter Section */}
      <div className="card mb-4 p-3">
        <div className="row gx-2 gy-2 align-items-end">

          <div className="col-auto">
            <label className="form-label">Filter Type</label>
            <select
              className="form-select form-select-sm"
              value={filterType}
              onChange={(e) => setFilterType(e.target.value)}
              onKeyDown={(e) => e.preventDefault()}
            >
              <option value="">Select</option>
              <option value="userId">User ID</option>
              <option value="userName">Username</option>
            </select>
          </div>

          {filterType && (
            <div className="col-auto">
              <label className="form-label">
                {filterType === 'userId' ? 'User ID' : 'Username'}
              </label>
              <input
                type={filterType === 'userId' ? 'number' : 'text'}
                className="form-control form-control-sm"
                value={filterValue}
                onChange={(e) => setFilterValue(e.target.value)}
                onKeyDown={handleKeyDown}
              />
            </div>
          )}

          <div className="col-auto">
            <label className="form-label">Status</label>
            <select
              className="form-select form-select-sm"
              value={status}
              onChange={(e) => setStatus(e.target.value)}
              onKeyDown={handleKeyDown}
            >
              <option value="">Select</option>
              <option value="1">Active</option>
              <option value="0">Inactive</option>
            </select>
          </div>

          <div className="col-auto">
            <button
              className="btn btn-sm btn-primary mt-1"
              onClick={fetchEmployees}
            >
              Search
            </button>
          </div>

        </div>
      </div>


      {/* ================= EMPLOYEE TABLE ================= */}

      <h5 className="mb-2">Employees</h5>

      <div className="table-responsive" style={{ overflowX: 'auto', whiteSpace: 'nowrap' }}>
        <table className="table tablestyle table-sm table-bordered table-hover align-middle">
          <thead className="table-dark">
            <tr>
              <th>S.No.</th>
              <th>User_ID</th>
              <th>Username</th>
              <th>Employee_Name</th>
              <th>Department</th>
              <th>Email</th>
              <th>Phone</th>
              <th>Status</th>
              <th>Joining_Date</th>
              {privilegeList.employeeEdit && <th>Action</th>}
            </tr>
          </thead>

          <tbody>

            {paginatedEmployees.length > 0 ? (

              paginatedEmployees.map((emp, index) => (

                <tr key={emp.user_id}>

                  <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>

                  <td>{emp.user_id}</td>

                  <td>{emp.user_name}</td>

                  <td>{emp.name}</td>

                  <td>{emp.dept}</td>

                  <td>{emp.email}</td>

                  <td>{emp.phone_number}</td>

                  <td>
                    <span
                      className={`badge rounded-pill ${
                        emp.is_active === 1
                          ? 'bg-success'
                          : 'bg-secondary'
                      }`}
                    >
                      {emp.is_active === 1 ? 'Active' : 'Inactive'}
                    </span>
                  </td>

                  <td>{emp.create_date}</td>

                  {privilegeList.employeeEdit && (

                    <td>
                      <button
                        className="btn btn-sm btn-primary"
                        onClick={() =>
                          (window.location.href =
                            `#/EmployeeView?UserId=${emp.user_id}`)
                        }
                      >
                        Edit
                      </button>
                    </td>

                  )}

                </tr>

              ))

            ) : (

              <tr>
                <td colSpan="10" className="text-center text-muted">
                  No employee records found.
                </td>
              </tr>

            )}

          </tbody>

        </table>
      </div>


      {/* PAGINATION */}

      {employeeSection.length > rowsPerPage && (

        <div className="d-flex justify-content-center mt-3">

          <div
            className="d-flex align-items-center overflow-auto"
            style={{ gap: '5px' }}
          >

            <button
              className="btn btn-sm btn-outline-primary"
              onClick={() =>
                setCurrentPage((p) => Math.max(p - 1, 1))
              }
              disabled={currentPage === 1}
            >
              Prev
            </button>

            {Array.from({ length: totalPages }, (_, i) => (

              <button
                key={i + 1}
                className={`btn btn-sm ${
                  currentPage === i + 1
                    ? 'btn-primary'
                    : 'btn-outline-primary'
                }`}
                onClick={() => setCurrentPage(i + 1)}
              >
                {i + 1}
              </button>

            ))}

            <button
              className="btn btn-sm btn-outline-primary"
              onClick={() =>
                setCurrentPage((p) =>
                  Math.min(p + 1, totalPages)
                )
              }
              disabled={currentPage === totalPages}
            >
              Next
            </button>

          </div>

        </div>

      )}


      {/* ================= DSA & AGENCY TABLE ================= */}

      <h5 className="mt-5 mb-2">DSA & Agency</h5>

      <div className="table-responsive" style={{ overflowX: 'auto', whiteSpace: 'nowrap' }}>
        <table className="table tablestyle table-sm table-bordered table-hover align-middle">
          <thead className="table-dark">
            <tr>
              <th>S.No.</th>
              <th>User_ID</th>
              <th>Username</th>
              <th>Name</th>
              <th>Department</th>
              <th>Email</th>
              <th>Phone</th>
              <th>Status</th>
              <th>Lms Register Date</th>
              {privilegeList.employeeEdit && <th>Action</th>}
            </tr>
          </thead>

          <tbody>

            {dsaSection.length > 0 ? (

              dsaSection.map((emp, index) => (

                <tr key={emp.user_id}>

                  <td>{index + 1}</td>

                  <td>{emp.user_id}</td>

                  <td>{emp.user_name}</td>

                  <td>{emp.name}</td>

                  <td>{emp.dept}</td>

                  <td>{emp.email}</td>

                  <td>{emp.phone_number}</td>

                  <td>
                    <span
                      className={`badge rounded-pill ${
                        emp.is_active === 1
                          ? 'bg-success'
                          : 'bg-secondary'
                      }`}
                    >
                      {emp.is_active === 1 ? 'Active' : 'Inactive'}
                    </span>
                  </td>

                  <td>{emp.create_date}</td>

                   {privilegeList.employeeEdit && (

                    <td>
                      <button
                        className="btn btn-sm btn-primary"
                        onClick={() =>
                          (window.location.href =
                            `#/EmployeeView?UserId=${emp.user_id}`)
                        }
                      >
                        Edit
                      </button>
                    </td>

                  )}


                </tr>

              ))

            ) : (

              <tr>
                <td colSpan="9" className="text-center text-muted">
                  No DSA / Agency records found.
                </td>
              </tr>

            )}

          </tbody>

        </table>

      </div>

    </div>
  );
};

export default EmployeeList;